/**
 * Gravity Work Listing Block - JavaScript
 * Handles AJAX filtering and infinite scroll
 */

(function() {
  'use strict';

  // Helper function to decode HTML entities
  function decodeHtmlEntities(str) {
    if (!str || typeof str !== 'string') return str;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    const workListingBlocks = document.querySelectorAll('.gravity-work-listing:not([data-initialized])');
    
    workListingBlocks.forEach(function(block) {
      // Mark block as initialized to prevent double initialization
      block.setAttribute('data-initialized', 'true');
      
      const uuid = block.dataset.uuid;
      const grid = block.querySelector('.gravity-work-listing__grid');
      
      // Exit if grid not found
      if (!grid) {
        console.warn('Gravity Work Listing: Grid element not found');
        return;
      }
      
      const postsPerPage = parseInt(grid.dataset.postsPerPage) || 6;
      
      // Filter state
      let activeParentCategory = 'all';
      let activeCategories = [];
      let currentPage = 1;
      let isLoading = false;
      let hasMore = true;
      // When a hash restore triggers an initial fetch, skip the later default fetch
      let skipInitialFetch = false;
      
      // Function to update parent category (shared by tabs and dropdown)
      function updateParentCategory(parentCategoryId, source) {
        activeParentCategory = parentCategoryId;
        
        // Clear active categories when switching parent category
        activeCategories = [];
        
        // Update filter pills visibility based on parent category
        updateFilterPills(parentCategoryId);
        
        // Reset pill active states
        updatePillStates();
        
        // Update tabs (if source is not tabs)
        if (source !== 'tabs') {
          tabs.forEach(function(tab) {
            if (tab.dataset.parentCategory === parentCategoryId) {
              tab.classList.add('gravity-work-listing__tab--active');
            } else {
              tab.classList.remove('gravity-work-listing__tab--active');
            }
          });
        }
        
        // Update dropdown text (if source is not dropdown)
        if (source !== 'dropdown') {
          const dropdownTextMobile = block.querySelector('.gravity-work-listing__dropdown-text');
          const dropdownItem = block.querySelector('.gravity-work-listing__dropdown-item[data-parent-category="' + parentCategoryId + '"]');
          if (dropdownTextMobile) {
            const selectedTab = Array.from(tabs).find(function(tab) {
              return tab.dataset.parentCategory === parentCategoryId;
            });
            if (selectedTab) {
              dropdownTextMobile.textContent = selectedTab.textContent.trim();
            } else if (parentCategoryId === 'all') {
              dropdownTextMobile.textContent = 'All Projects';
            }
          }
          if (dropdownItem) {
            const allItems = block.querySelectorAll('.gravity-work-listing__dropdown-item');
            allItems.forEach(function(item) {
              item.classList.remove('active');
            });
            dropdownItem.classList.add('active');
          }
        }
        
        // Reset pagination and fetch works
        currentPage = 1;
        hasMore = true; // Reset hasMore when filtering
        updateLoadingIndicator();
        fetchWorks();
      }
      
      // Filter tabs (Tablet/Desktop)
      const tabs = block.querySelectorAll('.gravity-work-listing__tab');

      // Helper to make a URL-friendly slug from a label
      function slugifyLabel(str) {
        if (!str) return '';
        return str.trim().toLowerCase().replace(/^by\s+/i, '').replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
      }

      // Update URL query params to reflect current filter state
      function updateUrlParams(tabSlug, filterSlugs) {
        try {
          const url = new URL(window.location.href);
          if (!tabSlug || tabSlug === 'all') {
            url.searchParams.delete('tab');
          } else {
            url.searchParams.set('tab', tabSlug);
          }
          if (!filterSlugs || filterSlugs.length === 0) {
            url.searchParams.delete('filter');
          } else {
            url.searchParams.set('filter', filterSlugs.join(','));
          }
          history.replaceState(null, '', url.toString());
        } catch (e) {
          // no-op if History API unavailable
        }
      }

      // Get the slug of the currently active tab
      function getActiveTabSlug() {
        const activeTab = Array.from(tabs).find(function(t) {
          return t.classList.contains('gravity-work-listing__tab--active');
        });
        return activeTab ? slugifyLabel(activeTab.textContent || '') : '';
      }

      // Get category slugs for all active pills
      function getActiveCategorySlugs() {
        return activeCategories.map(function(categoryId) {
          const pill = block.querySelector('.gravity-work-listing__pill[data-category-id="' + categoryId + '"]');
          return pill ? (pill.dataset.categorySlug || '') : '';
        }).filter(Boolean);
      }

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          const parentCategoryId = this.dataset.parentCategory;

          // Update active tab
          tabs.forEach(function(t) {
            t.classList.remove('gravity-work-listing__tab--active');
          });
          this.classList.add('gravity-work-listing__tab--active');

          // Update URL query params (tab change clears any pill filters)
          updateUrlParams(slugifyLabel(this.textContent || ''), []);

          // Update parent category
          updateParentCategory(parentCategoryId, 'tabs');
        });
      });

      // Infinite scroll - declare loadingIndicator BEFORE functions that may call updateLoadingIndicator
      const loadingIndicator = block.querySelector('.gravity-work-listing__loading');
      let observer = null;
      let initialLoadDone = false; // Track if initial load is complete to prevent immediate trigger

      // On load, restore tab and filter state from URL query params (?tab=industry&filter=healthcare,financial)
      (function restoreFromParams() {
        const url = new URL(window.location.href);
        const tabParam = url.searchParams.get('tab');
        const filterParam = url.searchParams.get('filter');

        if (!tabParam && !filterParam) return;

        const tabNormalized = (tabParam || '').trim().toLowerCase();

        const matchingTab = tabNormalized
          ? Array.from(tabs).find(function(tab) {
              return slugifyLabel(tab.textContent || '') === tabNormalized;
            })
          : null;

        if (matchingTab) {
          tabs.forEach(function(t) { t.classList.remove('gravity-work-listing__tab--active'); });
          matchingTab.classList.add('gravity-work-listing__tab--active');
          activeParentCategory = matchingTab.dataset.parentCategory;

          // Sync dropdown UI
          const dropdownTextEl = block.querySelector('.gravity-work-listing__dropdown-text');
          if (dropdownTextEl) dropdownTextEl.textContent = matchingTab.textContent.trim();
          const dropdownItemEl = block.querySelector('.gravity-work-listing__dropdown-item[data-parent-category="' + activeParentCategory + '"]');
          if (dropdownItemEl) {
            block.querySelectorAll('.gravity-work-listing__dropdown-item').forEach(function(i) { i.classList.remove('active'); });
            dropdownItemEl.classList.add('active');
          }

          // Show pills for this tab
          updateFilterPills(activeParentCategory);

          // Restore active pills from filter param
          if (filterParam) {
            const filterSlugs = filterParam.split(',').map(function(s) { return s.trim().toLowerCase(); });
            getPills().forEach(function(pill) {
              if (filterSlugs.includes((pill.dataset.categorySlug || '').toLowerCase())) {
                activeCategories.push(pill.dataset.categoryId);
              }
            });
            updatePillStates();
          }

          skipInitialFetch = true;
          currentPage = 1;
          hasMore = true;
          updateLoadingIndicator();
          fetchWorks();
        } else if (tabNormalized === 'all') {
          skipInitialFetch = true;
          updateParentCategory('all', 'params');
        }
      })();
      
      // Filter pills - get reference to pills container
      const pillsContainer = block.querySelector('.gravity-work-listing__filter-pills');
      
      // Function to get pills (refresh when needed)
      function getPills() {
        return block.querySelectorAll('.gravity-work-listing__pill');
      }
      
      // Attach event listeners to pills using event delegation
      if (pillsContainer) {
        pillsContainer.addEventListener('click', function(e) {
          // Find the pill button (could be clicked on button, span, or SVG)
          let pill = e.target.closest('.gravity-work-listing__pill');
          
          // If clicked on span or SVG inside pill, get the button
          if (!pill && (e.target.classList.contains('gravity-work-listing__pill-text') || e.target.closest('svg'))) {
            pill = e.target.closest('button.gravity-work-listing__pill') || e.target.closest('.gravity-work-listing__pill');
          }
          
          if (!pill) {
            return;
          }
          
          // Prevent default and stop propagation
          e.preventDefault();
          e.stopPropagation();
          
          // Check if pill is visible (not hidden)
          if (pill.style.display === 'none') {
            return;
          }
          
          const categoryId = pill.dataset.categoryId;
          if (!categoryId) {
            console.warn('Gravity Work Listing: Pill missing category-id', pill);
            return;
          }
          
          const categoryIdNum = parseInt(categoryId, 10);

          // Check if category is already in activeCategories array (source of truth)
          const isActive = activeCategories.some(function(id) {
            const idStr = String(id);
            const idNum = parseInt(id, 10);
            return idStr === String(categoryId) || idNum === categoryIdNum;
          });

          console.log('Pill clicked:', {
            categoryId: categoryId,
            categoryIdNum: categoryIdNum,
            isActive: isActive,
            activeCategoriesBefore: JSON.parse(JSON.stringify(activeCategories))
          });

          if (isActive) {
            // Deselect - clear the filter
            activeCategories = [];
            pill.dataset.active = 'false';
            pill.classList.remove('gravity-work-listing__pill--active');
          } else {
            // Single-select: clear all previous selections and select only this one
            activeCategories = [categoryId];
            pill.dataset.active = 'true';
            pill.classList.add('gravity-work-listing__pill--active');
          }

          console.log('After toggle:', {
            activeCategoriesAfter: JSON.parse(JSON.stringify(activeCategories)),
            pillActive: pill.dataset.active,
            pillHasActiveClass: pill.classList.contains('gravity-work-listing__pill--active')
          });
          
          // Update all pill states to sync UI with activeCategories
          updatePillStates();

          // Sync URL query params with current tab + pill selection
          updateUrlParams(getActiveTabSlug(), getActiveCategorySlugs());

          // Reset and fetch works
          currentPage = 1;
          hasMore = true; // Reset hasMore when filtering
          updateLoadingIndicator();
          fetchWorks();
        });
      } else {
        console.warn('Gravity Work Listing: Pills container not found');
      }
      
      // Initialize pills visibility on page load
      updateFilterPills(activeParentCategory);
      
      // Infinite scroll vars declared earlier so restoreFromHash can safely call updateParentCategory
      
      // Mobile dropdown
      const dropdownButton = block.querySelector('.gravity-work-listing__dropdown-button');
      const dropdownMenu = block.querySelector('.gravity-work-listing__dropdown-menu');
      const dropdownTextMobile = block.querySelector('.gravity-work-listing__dropdown-text');
      
      if (dropdownButton && dropdownMenu) {
        // Check if dropdown already initialized for this block
        if (dropdownButton.dataset.listenerAttached === 'true') {
          return;
        }
        dropdownButton.dataset.listenerAttached = 'true';
        
        // Toggle dropdown menu
        dropdownButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const isExpanded = this.getAttribute('aria-expanded') === 'true';
          const newExpanded = !isExpanded;
          this.setAttribute('aria-expanded', newExpanded);
          
          if (newExpanded) {
            dropdownMenu.style.display = 'flex';
          } else {
            dropdownMenu.style.display = 'none';
          }
        });
        
        // Handle dropdown item clicks using event delegation (prevents duplicate listeners)
        dropdownMenu.addEventListener('click', function(e) {
          const item = e.target.closest('.gravity-work-listing__dropdown-item');
          if (!item) return;
          
          e.preventDefault();
          e.stopPropagation();

          const listItem = $('.gravity-work-listing__dropdown-item');

          listItem.each(function() {
            $(this).removeClass('active');
          })
          
          item.classList.add('active');
          const parentCategoryId = item.dataset.parentCategory;
          const itemText = item.textContent.trim();
          
          // Update dropdown text
          if (dropdownTextMobile) {
            dropdownTextMobile.textContent = itemText;
          }

          // Update URL query params (tab change clears any pill filters)
          updateUrlParams(slugifyLabel(itemText), []);

          // Close dropdown
          dropdownButton.setAttribute('aria-expanded', 'false');
          dropdownMenu.style.display = 'none';

          // Update parent category (this will also update tabs and pills)
          updateParentCategory(parentCategoryId, 'dropdown');
        });
        
        // Close dropdown when clicking outside - block-specific handler
        const closeDropdownHandler = function(e) {
          // Only handle if this block's dropdown is open
          if (dropdownButton.getAttribute('aria-expanded') === 'true') {
            if (!block.contains(e.target)) {
              dropdownButton.setAttribute('aria-expanded', 'false');
              dropdownMenu.style.display = 'none';
            }
          }
        };
        
        // Use capture phase to catch clicks early
        document.addEventListener('click', closeDropdownHandler, true);
      }
      
      // Load initial works (this will trigger updateLoadingIndicator which will init observer)
      fetchWorks();
      
      // Initialize IntersectionObserver for infinite scroll
      function initInfiniteScroll() {
        // Disconnect existing observer if any
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        
        // Only create observer if loading indicator exists
        if (!loadingIndicator) {
          console.warn('Gravity Work Listing: Loading indicator not found');
          return;
        }
        
        // Only create observer if loading indicator is visible
        if (loadingIndicator.style.display === 'none' || loadingIndicator.offsetParent === null) {
          console.log('Loading indicator not visible, skipping observer init');
          return;
        }
        
        observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            // Only trigger if initial load is done (prevents immediate trigger on page load)
            if (entry.isIntersecting && hasMore && !isLoading && initialLoadDone) {
              console.log('IntersectionObserver triggered - Loading more works:', {
                currentPage: currentPage,
                nextPage: currentPage + 1,
                hasMore: hasMore,
                isLoading: isLoading,
                isIntersecting: entry.isIntersecting,
                intersectionRatio: entry.intersectionRatio
              });
              currentPage++;
              fetchWorks(true);
            }
          });
        }, {
          rootMargin: '200px',
          threshold: 0.1
        });
        
        // Observe loading indicator
        try {
          observer.observe(loadingIndicator);
          console.log('Observer started watching loading indicator');
        } catch (e) {
          console.error('Error observing loading indicator:', e);
        }
      }
      
      // Update loading indicator visibility based on hasMore
      function updateLoadingIndicator() {
        if (!loadingIndicator) {
          console.warn('Gravity Work Listing: Loading indicator not found in updateLoadingIndicator');
          return;
        }
        
        console.log('Updating loading indicator:', {
          hasMore: hasMore,
          isLoading: isLoading,
          currentPage: currentPage
        });
        
        if (hasMore && !isLoading) {
          // Show loading indicator when there are more pages
          loadingIndicator.style.display = 'block';
          
          // Use setTimeout to ensure element is visible before observing
          setTimeout(function() {
            // Initialize or re-observe
            if (!observer) {
              initInfiniteScroll();
            } else {
              // Re-observe if needed
              try {
                observer.observe(loadingIndicator);
                console.log('Re-observing loading indicator');
              } catch (e) {
                // Already observing or error, reinitialize
                console.log('Reinitializing observer:', e.message);
                initInfiniteScroll();
              }
            }
          }, 50);
        } else {
          // Hide loading indicator when no more pages
          loadingIndicator.style.display = 'none';
          if (observer) {
            try {
              observer.unobserve(loadingIndicator);
              console.log('Unobserving loading indicator - no more pages');
            } catch (e) {
              // Not observing, ignore error
            }
          }
        }
      }
      
      // Initialize infinite scroll after a short delay to ensure DOM is ready
      // This will be called after first fetchWorks completes
      
      // Update filter pills based on parent category
      function updateFilterPills(parentCategoryId) {
        const pillsContainer = block.querySelector('.gravity-work-listing__filter-pills');
        if (!pillsContainer) {
          console.warn('Gravity Work Listing: Pills container not found in updateFilterPills');
          return;
        }
        // Update container data attribute
        pillsContainer.setAttribute('data-parent-category', parentCategoryId);

        // If 'all' is selected we don't show sub-categories (hide the pills container)
        if (String(parentCategoryId).toLowerCase() === 'all') {
          // Hide container
          pillsContainer.style.display = 'none';

          // Also reset pill states for cleanliness
          const allPills = getPills();
          allPills.forEach(function(pill) {
            pill.dataset.active = 'false';
            pill.classList.remove('gravity-work-listing__pill--active');
          });

          console.log('Hiding filter pills for "all" parent category');
          return;
        }

        // Otherwise show container and filter pills by parent
        pillsContainer.style.display = '';
        // Get fresh pills list
        const pills = getPills();
        const parentCategoryIdStr = String(parentCategoryId);

        console.log('Updating filter pills:', {
          parentCategoryId: parentCategoryId,
          parentCategoryIdStr: parentCategoryIdStr,
          pillsCount: pills.length
        });

        // Show/hide pills based on parent category
        pills.forEach(function(pill) {
          const pillParentId = String(pill.dataset.parentId || '');
          if (pillParentId === parentCategoryIdStr) {
            // Show pills that belong to the selected parent category
            pill.style.display = '';
            pill.style.visibility = 'visible';
          } else {
            // Hide pills that don't belong to the selected parent category
            pill.style.display = 'none';
            pill.style.visibility = 'hidden';
          }
        });
      }
      
      // Update pill active states - sync UI with activeCategories array (source of truth)
      function updatePillStates() {
        const pills = getPills();
        
        pills.forEach(function(pill) {
          const categoryId = pill.dataset.categoryId;
          if (!categoryId) return;
          
          const categoryIdNum = parseInt(categoryId, 10);
          
          // Check if this category is in activeCategories (source of truth)
          const isActive = activeCategories.some(function(id) {
            const idStr = String(id);
            const idNum = parseInt(id, 10);
            return idStr === String(categoryId) || idNum === categoryIdNum;
          });
          
          // Always update data attribute (for state tracking)
          pill.dataset.active = isActive ? 'true' : 'false';
          
          // Only update visible pills' classes (for UI)
          if (pill.style.display !== 'none') {
            if (isActive) {
              pill.classList.add('gravity-work-listing__pill--active');
            } else {
              pill.classList.remove('gravity-work-listing__pill--active');
            }
          } else {
            // Remove active class if pill is hidden (cleanup)
            pill.classList.remove('gravity-work-listing__pill--active');
          }
        });
      }
      
      // Fetch works via AJAX
      function fetchWorks(append) {
        if (isLoading) return;
        
        isLoading = true;
        if (loadingIndicator) {
          loadingIndicator.style.display = 'block';
        }
        
        // Get AJAX URL - use localized object if available, otherwise fallback to window.AJAX_URL
        const ajaxUrl = (typeof gravityWorkListing !== 'undefined' && gravityWorkListing.ajaxUrl) 
          ? gravityWorkListing.ajaxUrl 
          : (typeof window.AJAX_URL !== 'undefined' ? window.AJAX_URL : '/wp-admin/admin-ajax.php');
        
        // Get nonce - use localized object if available, otherwise use empty string (will be handled server-side)
        const nonce = (typeof gravityWorkListing !== 'undefined' && gravityWorkListing.nonce) 
          ? gravityWorkListing.nonce 
          : '';
        
        // Build form data
        const formData = new URLSearchParams();
        formData.append('action', 'gravity_work_listing_fetch');
        formData.append('parent_category', activeParentCategory);
        formData.append('page', currentPage.toString());
        formData.append('per_page', postsPerPage.toString());
        if (nonce) {
          formData.append('nonce', nonce);
        }
        
        // Append categories array properly
        // Only send categories if they are selected (not when parent_category changes)
        if (activeCategories.length > 0) {
          activeCategories.forEach(function(categoryId) {
            formData.append('categories[]', categoryId);
          });
          console.log('Sending categories filter:', activeCategories);
        } else {
          console.log('No categories filter - showing all for parent:', activeParentCategory);
        }
        
        // Use fetch API
        fetch(ajaxUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formData
        })
        .then(function(response) {
          return response.json();
        })
        .then(function(result) {
          if (result.success && result.data) {
            if (append) {
              appendWorks(result.data.works);
            } else {
              replaceWorks(result.data.works);
            }
            
            // Update hasMore from response
            hasMore = result.data.has_more || false;
            
            console.log('Works loaded:', {
              page: currentPage,
              worksCount: result.data.works ? result.data.works.length : 0,
              hasMore: hasMore,
              totalPages: result.data.total_pages || 0
            });
            
            // Update loading indicator visibility
            updateLoadingIndicator();
            
            // Mark initial load as done after first successful load
            if (!initialLoadDone && currentPage === 1) {
              setTimeout(function() {
                initialLoadDone = true;
                
                // Check if loading indicator is already in viewport after initial load
                // This handles the case where user scrolled down before initial load completed
                if (loadingIndicator && hasMore && !isLoading) {
                  const rect = loadingIndicator.getBoundingClientRect();
                  const isInViewport = rect.top < window.innerHeight + 200; // 200px margin like observer
                  
                  if (isInViewport) {
                    currentPage++;
                    fetchWorks(true);
                  }
                }
              }, 300);
            }
          } else {
            console.error('Error fetching works:', result);
            hasMore = false;
            updateLoadingIndicator();
            initialLoadDone = true; // Mark as done even on error
          }
        })
        .catch(function(error) {
          console.error('AJAX error:', error);
          hasMore = false;
          updateLoadingIndicator();
          initialLoadDone = true; // Mark as done even on error
        })
        .finally(function() {
          isLoading = false;
          updateLoadingIndicator();
        });
      }
      
      // Replace works in grid
      function replaceWorks(works) {
        if (!grid) return;
        grid.innerHTML = '';
        appendWorks(works);
      }
      
      // Append works to grid
      function appendWorks(works) {
        if (!grid) return;
        
        if (!works || works.length === 0) {
          const empty = document.createElement('div');
          empty.className = 'gravity-work-listing__empty';
          empty.innerHTML = '<p class="text-h3-xl">No works found matching your filters.</p>';
          grid.appendChild(empty);
          grid.classList.add('gravity-work-listing__grid--empty', 'min-h-not-found');
          return;
        }
        grid.classList.remove('gravity-work-listing__grid--empty', 'min-h-not-found');
        
        works.forEach(function(work) {
          const card = createWorkCard(work);
          grid.appendChild(card);
        });
      }
      
      // Create work card element
      function createWorkCard(work) {
        const article = document.createElement('article');
        article.className = 'gravity-work-listing__card';
        
        const link = document.createElement('a');
        link.href = work.permalink;
        link.className = 'gravity-work-listing__card-link';
        
        // Image container
        const imageContainer = document.createElement('div');
        imageContainer.className = 'gravity-work-listing__card-image';
        const displayTitle = work.work_title || work.title;
        
        if (work.thumbnail) {
          const img = document.createElement('img');
          img.src = work.thumbnail;
          img.alt = work.title;
          img.className = 'gravity-work-listing__image';
          imageContainer.appendChild(img);
        }

        if (work.image_default && !work.thumbnail && !work.hover_gif) {
          const img = document.createElement('img');
          img.src = work.image_default;
          img.alt = work.title;
          img.className = 'gravity-work-listing__image';
          imageContainer.appendChild(img);
        }
        
        if (work.hover_gif) {
          const hoverImg = document.createElement('img');
          hoverImg.src = work.hover_gif;
          hoverImg.alt = work.title + ' animation';
          hoverImg.className = 'gravity-work-listing__hover-gif';
          imageContainer.appendChild(hoverImg);
        }

        
        link.appendChild(imageContainer);
        
        // Content container
        const content = document.createElement('div');
        content.className = 'gravity-work-listing__card-content';
        
        const textContainer = document.createElement('div');
        textContainer.className = 'gravity-work-listing__card-text';
        
        const title = document.createElement('h3');
        title.className = 'gravity-work-listing__card-title h6 mb-0';
        title.textContent = work.work_title || work.title;
        textContainer.appendChild(title);
        
        if (work.client_name) {
          const client = document.createElement('p');
          client.className = 'gravity-work-listing__card-client';
          client.textContent = work.client_name;
          textContainer.appendChild(client);
        }
        
        content.appendChild(textContainer);
        
        if (work.category) {
          const tag = document.createElement('div');
          tag.className = 'gravity-work-listing__card-tag';
          const tagText = document.createElement('span');
          tagText.className = 'gravity-work-listing__tag-text';
          tagText.textContent = decodeHtmlEntities(work.category);
          tag.appendChild(tagText);
          content.appendChild(tag);
        }
        
        link.appendChild(content);
        article.appendChild(link);
        
        return article;
      }
    });
  });
})();
